import script from "./YearlyChart.vue?vue&type=script&lang=js"
export * from "./YearlyChart.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__